// import React, { useEffect, useState } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import MuiAppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import CssBaseline from "@mui/material/CssBaseline";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import logo from "../assets/logo.png";
// import Cookies from 'js-cookie';
// import toast from "react-hot-toast";

// import { FaFirstAid, FaUserInjured } from 'react-icons/fa';

// import { Popover, Transition } from "@headlessui/react";

// import { useLocation, useNavigate } from "react-router-dom";
// import { IoIosArrowDown } from "react-icons/io";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import NotificationsIcon from "@mui/icons-material/Notifications";

// import AccountCircleIcon from "@mui/icons-material/AccountCircle";

// import {
//   SESSION_IS_AUTHENTICATED,
//   SESSION_USERINFO,
// } from "../Utills/Constants";
// //import { useDispatch } from "react-redux";
// import { MedicalInformation, PeopleAltRounded } from "@mui/icons-material";

// const drawerWidth = 240;

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   // necessary for content to be below app bar
//   ...theme.mixins.toolbar,
// }));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// export default function PortalLayout({ children }) {
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(true);

//   const handleDrawer = () => {
//     setOpen(!open);
//   };
//   const route = useNavigate();
//   const location = useLocation();

//   const [isOpen, setIsOpen] = React.useState(false);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };
//   const [out, setOut] = React.useState();
//   const handleClick = () => setOut(!open);

//   const [open1, setOpen1] = useState([
//     false,
//     false,
//     false,
//     false,
//     false,
//     false,
//     false,
//     false,
//   ]);

//   const handleSelection = (index) => {
//     let op = [...open1];
//     op[index] = !op[index];
//     setOpen1(op);
//   };

//   const navigate = useNavigate();

//   const handleLogout = () => {
//     localStorage.removeItem('user')
//     Cookies.remove('XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk=')
//     toast.success("Logout Successfully")
//     navigate('/login', { replace: true });
//   }

//   const [userEmail, setUserEmail] = useState("");

//   useEffect(() => {
//     const email = sessionStorage.getItem("userEmail");
//     if (email) {
//       setUserEmail(email);
//     }
//   }, []);


//   return (
//     <>
//       {location.pathname === "/login" ? (
//         children
//       ) : (
//         <>
//           <div className=" !flex !items-center">
//             <CssBaseline />
//             <AppBar
//               className={`!bg-white    !rounded-3xl !shadow-none mt-[-7px] ${
//                 open ? `!w-[84%]"` : `!w-[94%]`
//               }`}
//               sx={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)" }}
//               open={open}
//             >
//               <Toolbar>
//                 <IconButton
//                   aria-label="open drawer"
//                   onClick={handleDrawer}
//                   edge="start"
//                   sx={{ marginLeft: 1 }}
//                 >
//                   <MenuIcon className="text-gray-600 mt-[4px] " />
//                 </IconButton>
//                 {/* <div className="w-[50%] m-auto relative mt-[16px]">
//                                     <input
//                                         type="search"
//                                         className="w-full border-2 rounded-xl px-10 py-[4px] focus:outline-none text-gray-600"
//                                         placeholder="Search"
//                                     />
//                                     <SearchIcon className="absolute top-1/2 left-2 transform -translate-y-1/2 text-gray-600 " />
//                                 </div> */}

//                 <div className="ml-auto flex gap-2 items-center">
//                   {/* <NotificationsIcon
//                     className="text-gray-600 "
//                     sx={{ fontSize: 20 }}
//                   /> */}

//                   <div className="flex items-center gap-2">
//                     <AccountCircleIcon
//                       className="text-gray-600 "
//                       sx={{ fontSize: 22 }}
//                     />
//                     <Popover className="ml-auto">
//                       <Popover.Button
//                         onClick={toggleMenu}
//                         className="flex gap-2 outline-none md:mr-6 cursor-pointer text-gray-700"
//                       >
//                         <IoIosArrowDown
//                           className={`w-4 h-4 ${
//                             isOpen
//                               ? "-rotate-180 duration-300"
//                               : "rotate-0 duration-300"
//                           }    `}
//                         />
//                       </Popover.Button>
//                       <Transition
//                         as={React.Fragment}
//                         enter="transition ease-out duration-100"
//                         enterFrom="transform scale-95"
//                         enterTo="transform scale-100"
//                         leave="transition ease-in duration-75"
//                         leaveFrom="transform scale-100"
//                         leaveTo="transform scale-95"
//                       >
//                         <Popover.Panel className="absolute right-10 bg-gray-50 border-2 border-gray-300 shadow-lg rounded-md  w-[150px] text-black">
//                           <div>
//                             <div
//                               className="flex text-gray-600 gap-6 p-2 cursor-pointer"
//                               onClick={() => handleLogout()}
//                             >
//                               <PowerSettingsNewIcon className="text-gray-600" />
//                               <h1>LogOut</h1>
//                             </div>
//                           </div>
//                         </Popover.Panel>
//                       </Transition>
//                     </Popover>
//                   </div>
//                 </div>
//               </Toolbar>
//             </AppBar>
//             <Drawer
//               variant="permanent"
//               open={open}
//               sx={{
//                 flexShrink: 0,
//                 "& .MuiDrawer-paper": {
//                   borderWidth: 0,
//                   boxSizing: "border-box",
//                   borderTopRightRadius: 40,
//                   borderBottomRightRadius: 40,
//                   backgroundColor: "#F9F9F9",
//                   zIndex: "9999",
//                   boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.1)",
//                 },
//                 border: "none",
//               }}
//             >
//               <div>
//                 <img
//                   src={logo}
//                   alt=""
//                   className={`${
//                     open ? "w-[5rem]" : "w-[3rem]"
//                   }  ml-auto mr-auto my-4`}
//                 />
//               </div>

//               <div>
                      
//                 <ul className={`w-[100%]`}>

//                   {/* <li>
//                     <div
//                       onClick={() => route("/")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/" ||
//                         location.pathname === "/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <PeopleAltRounded
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         HR Dashboard
//                       </span>
//                     </div>
//                   </li> */}

//                   <li>
//                     <div
//                       onClick={() => route("/staff")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/staff" ||
//                         location.pathname === "/staff/AddEditStaff"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <PeopleAltRounded
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/staff"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/staff"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Manage Staff
//                       </span>
//                     </div>
//                   </li>

//                   <li>
//                     <div
//                       onClick={() => route("/doctor")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/doctor" ||
//                         location.pathname === "/doctor/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <FaFirstAid
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/doctor"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/doctor"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Manage Doctors
//                       </span>
//                     </div>
//                   </li>

//                   <li>
//                     <div
//                       onClick={() => route("/roles")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/roles" ||
//                         location.pathname === "/roles/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <FaFirstAid
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/roles"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/roles"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Manage Roles
//                       </span>
//                     </div>
//                   </li>
//                   {/* <li>
//                     <div
//                       onClick={() => route("/hr/patients")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/hr/patients" ||
//                         location.pathname === "/hr/patients/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <FaUserInjured
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/hr/patients"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/hr/patients"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                          Patients
//                       </span>
//                     </div>
//                   </li> */}
                
//                 </ul> 
              
//               </div>
//             </Drawer>
//             <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
//               <DrawerHeader />

//               <div
//                 className={`${
//                   location.pathname === "/login" || location.pathname === "/"
//                     ? "p-4"
//                     : "bg-gray-100 min-h-[80vh]  p-6 rounded-xl m-4"
//                 } `}
//               >
//                 {children}
//               </div>
//             </Box>
//           </div>
//         </>
//       )}
//     </>
//   );
// }
import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/logo1.png";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

import { FaRegUser } from "react-icons/fa";
import { Popover, Transition } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { PeopleAltRounded } from "@mui/icons-material";
import { MdManageAccounts } from "react-icons/md";
import { FaUserDoctor } from "react-icons/fa6";
import { MdOutlineCalendarMonth } from "react-icons/md";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import {
  SESSION_IS_AUTHENTICATED,
  SESSION_USERINFO,
} from "../Utills/Constants";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

// AppBar: full width on mobile, adjusts for sidebar on md+
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
})(({ theme, open, isMobile }) => ({
  position: "fixed !important",
  top: 8,
  right: 8,
  zIndex: theme.zIndex.drawer + 1,
  width: isMobile
    ? "calc(100% - 16px)"
    : open
    ? `calc(100% - ${drawerWidth}px - 16px)`
    : `calc(100% - ${theme.spacing(8)} - 1px - 16px)`,
  marginLeft: isMobile
    ? 0
    : open
    ? drawerWidth
    : `calc(${theme.spacing(8)} + 1px)`,
  background: "transparent !important",
  boxShadow: "none !important",
  transition: theme.transitions.create(["width", "margin-left"], {
    easing: theme.transitions.easing.sharp,
    duration: open
      ? theme.transitions.duration.enteringScreen
      : theme.transitions.duration.leavingScreen,
  }),
}));

// Desktop persistent drawer
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const NAV_COLORS = {
  staff:      { bg: "#E3ECF6", border: "#BBD6F5", icon: "#2F6DB4", iconBg: "#e0f5ee", label: "#2F6DB4", bar: "#2F6DB4" },
  doctor:     { bg: "#E3ECF6", border: "#BBD6F5", icon: "#2F6DB4", iconBg: "#e0f5ee", label: "#2F6DB4", bar: "#2F6DB4" },
  roles:      { bg: "#E3ECF6", border: "#BBD6F5", icon: "#2F6DB4", iconBg: "#e0f5ee", label: "#2F6DB4", bar: "#2F6DB4" },
  dutyRoster: { bg: "#E3ECF6", border: "#BBD6F5", icon: "#2F6DB4", iconBg: "#e0f5ee", label: "#2F6DB4", bar: "#2F6DB4" },
  attendance: { bg: "#E3ECF6", border: "#BBD6F5", icon: "#2F6DB4", iconBg: "#e0f5ee", label: "#2F6DB4", bar: "#2F6DB4" },
  
};

// Shared sidebar content
function DrawerContent({ open, location, navigate, onNavClick }) {
  return (
    <>
      {/* Logo */}
      <div className="relative flex items-center justify-center px-3 border-b border-gray-100 mb-2">
        <img
          src={logo}
          alt="Hospital Logo"
          className={`object-contain transition-all duration-300 ${open ? "w-48 h-48" : "w-22 h-22"}`}
        />
      </div>

      {/* Section label */}
      {open && (
        <p className="text-[10px] font-bold tracking-[1.2px] uppercase pt-2 text-gray-400 px-5 pb-1 m-0">
          Navigation
        </p>
      )}

      {/* Nav items */}
      <nav className="py-1">
        <NavItem
          icon={PeopleAltRounded}
          label="Manage Staff"
          isActive={
            location.pathname === "/staff" ||
            location.pathname === "/staff/AddEditStaff"
          }
          open={open}
          onClick={() => { navigate("/staff"); onNavClick?.(); }}
          color={NAV_COLORS.staff}
        />
        <NavItem
          icon={FaUserDoctor}
          label="Manage Doctors"
          isActive={
            location.pathname === "/doctor" ||
            location.pathname === "/doctor/add"
          }
          open={open}
          onClick={() => { navigate("/doctor"); onNavClick?.(); }}
          color={NAV_COLORS.doctor}
        />
        <NavItem
          icon={MdManageAccounts}
          label="Manage Roles"
          isActive={
            location.pathname === "/roles" ||
            location.pathname === "/roles/add"
          }
          open={open}
          onClick={() => { navigate("/roles"); onNavClick?.(); }}
          color={NAV_COLORS.roles}
        />
        <NavItem
        icon={MdOutlineCalendarMonth}
        label="Manage Duties"
        isActive={location.pathname === "/duty-roster"}
        open={open}
        onClick={() => navigate("/duty-roster")}
        color={NAV_COLORS.dutyRoster}
      />
      <NavItem
        icon={AccessTimeIcon}
        label="Attendance"
        isActive={location.pathname === "/attendance"}
        open={open}
        onClick={() => { navigate("/attendance"); onNavClick?.(); }}
        color={NAV_COLORS.attendance}
      />
      </nav>
    </>
  );
}

export default function PortalLayout({ children }) {
  const theme = useTheme();
  const [open, setOpen] = useState(true);             // desktop sidebar
  const [mobileOpen, setMobileOpen] = useState(false); // mobile overlay
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Detect mobile breakpoint
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 900);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  // Close mobile drawer on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleDrawer = () => {
    if (isMobile) setMobileOpen(!mobileOpen);
    else setOpen(!open);
  };

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    localStorage.removeItem("user");
    Cookies.remove("XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk=");
    toast.success("Logout Successfully");
    navigate("/login", { replace: true });
  };

  const [userEmail, setUserEmail] = useState("");
  useEffect(() => {
    const email = sessionStorage.getItem("userEmail");
    if (email) setUserEmail(email);
  }, []);

  const getPageTitle = () => {
    const map = {
      "/staff": "Manage Staff",
      "/staff/AddEditStaff": "Manage Staff",
      "/doctor": "Manage Doctors",
      "/doctor/add": "Manage Doctors",
      "/roles": "Manage Roles",
      "/roles/add": "Manage Roles",
      "/duty-roster": "Duty Roster",
      "/attendance": "Attendance",
    };
    return map[location.pathname] || "Dashboard";
  };

  const drawerPaperSx = {
    border: "none",
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    background: "#ffffff",
    boxShadow: "6px 0 32px rgba(0,0,0,0.10)",
    overflow: "hidden",
    zIndex: 9999,
  };

  return (
    <>
      {location.pathname === "/login" ? (
        children
      ) : (
        <div className="flex items-stretch min-h-screen bg-slate-100">
          {/* Google Font */}
          <style>{`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'); * { font-family: 'Plus Jakarta Sans', sans-serif; }`}</style>
          <CssBaseline />

          {/* ── TOP BAR ── */}
          <AppBar open={open} isMobile={isMobile}>
            <div className="rounded-2xl border border-white/70 bg-white/85 backdrop-blur-xl shadow-[0_4px_24px_rgba(0,0,0,0.08)]">
              <Toolbar className="!min-h-[56px] !px-3">

                <IconButton
                  onClick={handleDrawer}
                  edge="start"
                  className="!mr-2 !w-9 !h-9 !rounded-xl !bg-gray-700/[0.07] hover:!bg-gray-700/[0.14] !transition-colors"
                >
                  <MenuIcon className="!text-[20px] !text-gray-700" />
                </IconButton>

                <div className="ml-2 min-w-0">
                  <p className="text-[14px] sm:text-[15px] font-bold text-gray-700 m-0 leading-tight truncate">
                    {getPageTitle()}
                  </p>
                  <p className="text-[10px] sm:text-[11px] text-gray-400 m-0">
                    {new Date().toLocaleDateString("en-US", {
                      weekday: "long",
                      month: "short",
                      day: "numeric",
                    })}
                  </p>
                </div>

                <div className="ml-auto flex items-center gap-2 sm:gap-3 flex-shrink-0">
                  <Popover className="relative">
                    <Popover.Button
                      as="div"
                      onClick={toggleMenu}
                      className="flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3 py-[6px] rounded-full cursor-pointer select-none
                        bg-gradient-to-r from-[#2F6DB4] via-[#5894d9] to-white/90
                        shadow-[0_2px_12px_rgba(0,0,0,0.2)]
                        hover:shadow-[0_4px_20px_rgba(0,0,0,0.3)] transition-shadow duration-200"
                    >
                      <AccountCircleIcon className="!text-[20px] !text-white/90" />
                      <IoIosArrowDown
                        className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-white/70 transition-transform duration-300"
                        style={{ transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)" }}
                      />
                    </Popover.Button>

                    <Transition
                      as={React.Fragment}
                      enter="transition ease-out duration-150"
                      enterFrom="opacity-0 -translate-y-2"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 -translate-y-2"
                    >
                      <Popover.Panel
                        className="absolute top-[calc(100%+10px)] right-0 z-[9999]
                          min-w-[200px] sm:min-w-[220px] rounded-2xl overflow-hidden
                          bg-white/[0.97] backdrop-blur-xl
                          border border-gray-700/10
                          shadow-[0_20px_60px_rgba(0,0,0,0.15)]"
                      >
                        <div className="flex items-center gap-2.5 p-4 bg-gradient-to-r from-[#2F6DB4] via-[#5894d9] to-white/90">
                          <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                            <FaRegUser className="text-white text-base" />
                          </div>
                          <div>
                            <p className="text-white/60 text-[11px] m-0">HR</p>
                          </div>
                        </div>

                        <div
                          onClick={handleLogout}
                          className="flex items-center gap-2.5 m-2.5 px-3.5 py-2.5 rounded-xl cursor-pointer
                            bg-gradient-to-r from-red-500 to-red-600
                            text-white font-semibold text-[13px]
                            shadow-[0_3px_12px_rgba(239,68,68,0.3)]
                            hover:-translate-y-px hover:shadow-[0_6px_18px_rgba(239,68,68,0.4)]
                            transition-all duration-200"
                        >
                          <PowerSettingsNewIcon className="!text-[18px]" />
                          <span>Sign Out</span>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </Popover>
                </div>

              </Toolbar>
            </div>
          </AppBar>

          {/* ── MOBILE DRAWER (overlay) ── */}
          {isMobile && (
            <>
              {/* Backdrop */}
              {mobileOpen && (
                <div
                  className="fixed inset-0 bg-black/40 z-[9998] backdrop-blur-sm"
                  onClick={() => setMobileOpen(false)}
                />
              )}
              {/* Slide-in panel */}
              <div
                className="fixed top-0 left-0 h-full z-[9999] bg-white shadow-2xl transition-transform duration-300 overflow-y-auto"
                style={{
                  width: drawerWidth,
                  borderTopRightRadius: 12,
                  borderBottomRightRadius: 12,
                  transform: mobileOpen ? "translateX(0)" : `translateX(-${drawerWidth}px)`,
                }}
              >
                <DrawerContent
                  open={true}
                  location={location}
                  navigate={navigate}
                  onNavClick={() => setMobileOpen(false)}
                />
              </div>
            </>
          )}

          {/* ── DESKTOP DRAWER (persistent) ── */}
          {!isMobile && (
            <Drawer
              variant="permanent"
              open={open}
              sx={{ "& .MuiDrawer-paper": drawerPaperSx }}
            >
              <DrawerContent
                open={open}
                location={location}
                navigate={navigate}
              />
            </Drawer>
          )}

          {/* ── MAIN CONTENT ── */}
          <Box component="main" sx={{ flexGrow: 1, p: 0, minWidth: 0 }}>
            <DrawerHeader />
            <div
              className={`${
                location.pathname === "/login" || location.pathname === "/"
                  ? "p-3 sm:p-4"
                  : "bg-gradient-to-br from-gray-50 to-gray-100 min-h-[calc(100vh-80px)] p-3 sm:p-4 mr-0 sm:mr-2 mb-2 rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.06)]"
              }`}
            >
              {children}
            </div>
          </Box>

        </div>
      )}
    </>
  );
}

/* ── Reusable Nav Item ── */
function NavItem({ icon: Icon, label, isActive, open, onClick, hasSubmenu, submenuOpen, color, badge }) {
  const c = color ?? {
    bg: "#f3f4f6",
    border: "#d1d5db",
    icon: "#6b7280",
    iconBg: "#f3f4f6",
    label: "#374151",
    bar: "#6b7280",
  };

  return (
    <div
      onClick={onClick}
      title={!open ? label : ""}
      className={[
        "relative flex items-center cursor-pointer rounded-xl overflow-hidden",
        "mx-2 my-[2px] px-[10px] py-[8px]",
        "border transition-all duration-200",
      ].join(" ")}
      style={
        isActive
          ? { background: c.bg, borderColor: c.border, boxShadow: `0 2px 8px ${c.icon}22` }
          : { background: "transparent", borderColor: "transparent" }
      }
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.background = "#f8f9fa";
          e.currentTarget.style.borderColor = "#e5e7eb";
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.borderColor = "transparent";
        }
      }}
    >
      {/* Icon wrap */}
      <div
        className="flex items-center justify-center w-[32px] h-[32px] rounded-[8px] flex-shrink-0 transition-all duration-200"
        style={
          isActive
            ? { background: c.icon }
            : { background: "#f1f3f5", border: "1px solid #e5e7eb" }
        }
      >
        <Icon
          sx={{ fontSize: 17 }}
          style={{ fontSize: 17, color: isActive ? "#fff" : "#6b7280" }}
        />
      </div>

      {/* Label */}
      <span
        className={[
          "ml-[10px] text-[13px] font-semibold whitespace-nowrap overflow-hidden transition-all duration-300 flex-1",
          open ? "max-w-[160px] opacity-100" : "max-w-0 opacity-0",
        ].join(" ")}
        style={{ color: isActive ? c.label : "#4b5563" }}
      >
        {label}
      </span>

      {/* Badge */}
      {badge && open && (
        <span
          className="text-[10px] font-bold px-[7px] py-[2px] rounded-full ml-auto"
          style={{ background: c.bg, color: c.icon, border: `1px solid ${c.border}` }}
        >
          {badge}
        </span>
      )}

      {/* Submenu arrow */}
      {hasSubmenu && open && (
        <IoIosArrowDown
          className="w-3 h-3 transition-transform duration-300 ml-auto"
          style={{ color: "#9ca3af", transform: submenuOpen ? "rotate(-180deg)" : "rotate(0deg)" }}
        />
      )}

      {/* Active indicator bar */}
      {isActive && (
        <div
          className="absolute right-0 top-1/2 -translate-y-1/2 w-[3px] h-[55%] rounded-l"
          style={{ background: c.bar }}
        />
      )}
    </div>
  );
}
